<button (click)="toggleArchived.emit(!showArchived)" class="btn btn-primary d-flex justify-content-between align-items-center">
  <i [class]="'al-icon sm ' + (showArchived? ' al-ico-exit-archive' : 'al-ico-archive' )"></i>
  <span class="button-label">{{showArchived? 'EXIT': 'OPEN'}} ARCHIVE</span>
</button>
